import axios from "axios";
import { configUrl } from "../../config";

export const addPredictorType = async (userId, selectedPredictor) => {
    try {
        const response = await axios.post(`${configUrl.AssessmentServer}/api/User/AddPredictorType/${userId}/${selectedPredictor}`);
        return response;
    } catch (error) {
        console.error('Error adding rank to user:', error);
        throw error;
    }
};
